import "./App.css";
import AppRouter from "../router";

function App() {
  return <AppRouter />;
}

export default App;
